/* istanbul ignore file */
enum InstrumentTestOutcome {
  Pass = 'Pass',
  Fail = 'Fail',
}

export default InstrumentTestOutcome;
